import { render, staticRenderFns } from "./secondary-button.vue?vue&type=template&id=0a95717a&scoped=true&"
import script from "./secondary-button.vue?vue&type=script&lang=js&"
export * from "./secondary-button.vue?vue&type=script&lang=js&"
import style0 from "./secondary-button.vue?vue&type=style&index=0&id=0a95717a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a95717a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VHover,VIcon})
